import screenbanner from "./image/background/1.jpg";
import mobilebanner from "./image/background/2.jpg";

import w from "./image/Location/w.png"
import c from "./image/Location/c.png"
import e from "./image/Location/e.png"


export const BannerData = {
  screenbanner: screenbanner,
  mobilebanner: mobilebanner,
};
export const LocationData = {
  taglineheading: "Hot Localities in Pune",
  locationtag: "",
  location: [
    {
      title: "West Pune",
      propertcount: 4,
      image: w,
      link: `/location/pune/west`,
    },
    {
      title: "Central Pune",
      propertcount: 1,
      image: c,
      link: `/location/pune/center`,
    },
    
    {
      title: "East Pune",
      propertcount: 1,
      image: e,
      link: `/location/pune/east`,
    },
   
    
  ],
};
